import React, {ReactElement} from "react";
import {
  PAGE_INTERVAL_KTM,
  PAGE_TRANSITION_KTM,
  PageElement, PageInterval,
  PageTransition,
  Preferences
} from "@/smilebook-shared/types";
import {StyledBoxColumn, StyledBoxRowWithLabel} from "@/shared/StyledComponents";
import {MenuItem, Select} from "@mui/material";

export function SidebarContentPreferences(props: {
  selectedElement: PageElement,
  selectedPreferences: Preferences,
  setSelectedPreferences: (preferences: Preferences) => void
}): ReactElement {
  const prefs = props.selectedPreferences;
  return <StyledBoxColumn>
    <StyledBoxRowWithLabel label={"Page Transition"}>
      <Select
        variant={"outlined"}
        size={"small"}
        value={prefs.pageTransition}
        onChange={e => {
          prefs.pageTransition = e.target.value as PageTransition;
          props.setSelectedPreferences(prefs);
        }}>
        {PAGE_TRANSITION_KTM.values.map(value => <MenuItem value={value.key}>{value.metadata.text}</MenuItem>)}
      </Select>
    </StyledBoxRowWithLabel>
    <StyledBoxRowWithLabel label={"Page Interval"}>
      <Select
        variant={"outlined"}
        size={"small"}
        value={prefs.pageInterval}
        onChange={e => {
          prefs.pageInterval = e.target.value as PageInterval;
          props.setSelectedPreferences(prefs);
        }}>
        {PAGE_INTERVAL_KTM.values.map(value => <MenuItem value={value.key}>{value.metadata.text}</MenuItem>)}
      </Select>
    </StyledBoxRowWithLabel>
  </StyledBoxColumn>;
}